/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Lede_1Inputs */

const en_home_hero_lede_1 = /** @type {(inputs: Home_Hero_Lede_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save hours on the work that repeats. Find and follow up new revenue.`)
};

const lv_home_hero_lede_1 = /** @type {(inputs: Home_Hero_Lede_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ietaupiet laiku darbos, kas atkārtojas. Atrodiet jaunus klientus un sekojiet tiem līdzi.`)
};

/**
* | output |
* | --- |
* | "Save hours on the work that repeats. Find and follow up new revenue." |
*
* @param {Home_Hero_Lede_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_lede_1 = /** @type {((inputs?: Home_Hero_Lede_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Lede_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_lede_1(inputs)
	return en_home_hero_lede_1(inputs)
});